import { FETCH_ANCHORAGE_GEO_DATA_SUCCESS } from "./map-data.action";

export const UPDATE_FILTER = "Update Filter"
export const RESET_FILTER = "Reset Filter"

export const FETCH_AREAS = "Fetch Areas"
export const FETCH_AREAS_SUCCESS = "Fetch Areas Success"
export const FETCH_AREAS_FAILURE = "Fetch Areas Failure"

export const FETCH_DEFICIENCY_CODES = "Fetch Deficiency Codes"
export const FETCH_DEFICIENCY_CODES_SUCCESS = "Fetch Deficiency Codes Success"
export const FETCH_DEFICIENCY_CODES_FAILURE = "Fetch Deficiency Codes Failure"

export const updateFilter = (data) => ({
  type: UPDATE_FILTER,
  payload: data
});

export const resetFilter = () => ({
  type: RESET_FILTER,
});


export const fetchAreas = (data) => ({
  type: FETCH_AREAS,
  payload: data
});

export const fetchDeficiencyCodes = (data) => ({
  type: FETCH_DEFICIENCY_CODES,
  payload: data
});
